import { Component, OnInit, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/core/services/product.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-categories-person',
  templateUrl: './categories-person.component.html',
  styleUrls: ['./categories-person.component.css']
})
export class CategoriesPersonComponent implements OnInit {
  public productList = new Array();
  selectedId = 0;
  cont = 0;
  selectedItem = 0;
  categories: any[];
  public urlHost = "";
  public loading:boolean=true;
  constructor(private productService: ProductService,
    private elementRef: ElementRef,
    private route: ActivatedRoute) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
    const id = this.route.snapshot.params.id;
    if(id){
      this.selectedId=id;
      this.getCategories(false);
      this.getProductList(id);
      return;
    }
    this.getCategories(true);
  }

  getCategories(cargar:boolean) {
    this.loading=true;
    this.productService.getCategories().subscribe(
      (data) => {
        this.categories = data;
        this.loading=false;
        if(cargar){
          this.selectedItem = this.categories[0];
          this.selectedId = this.categories[0].codCategoria;
          this.getProductList(this.categories[0].codCategoria);
        }else{
          this.selectedItem = this.categories.find(category => category.codCategoria === this.selectedId);
        }
      },
      (error) => {
        this.loading=false;
        //console.log(error);
      }
    );
    console.log(this.selectedId)
  }

  getProductList(codCategoria) {
    this.loading = true;
    this.productService.getProductList(codCategoria).subscribe(
      (data) => {
        this.productList = data;
        //console.log(this.productList);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }
  getValidate(product: any): boolean {
    let valido = this.productService.getValidate(product);
    //console.log(valido);
    return valido;
  }
  listClick(event, newValue) {
    //console.log(newValue);
    this.selectedItem = newValue;
    this.selectedId=newValue.codCategoria;
    this.cont = 1;  // don't forget to update the model here
    // ... do other stuff here ...
  }

}
